import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const fringeThresholdsRoutesDictionary = moduleRouteDictionaryFactory(
  'fringeThresholds',
  'fringeThresholds',
  {
    list: 'list',
  },
);
